export default __webpack_public_path__ + "static/media/Vdoffer.b4d6cedd.jpeg";